import { FontWeights, Text, TextProps } from "@flat-ui";
import { PropsWithChildren } from "react";
import { useMediaQueries } from "@hooks/use-media-queries";

interface Props extends PropsWithChildren {
  /** Optional style props to pass to the component */
  sx?: TextProps["sx"];
}

/** Common component to display the title of a page */
export function PageTitle({ children, sx }: Props): JSX.Element {
  const { isSmallHeightScreen } = useMediaQueries();

  return (
    <Text
      variant="heading32"
      component="p"
      sx={{
        marginTop: isSmallHeightScreen ? "20px" : "80px",
        // `heading32` is Bold; the entry page has always drawn its titles semi-bold.
        fontWeight: FontWeights.SemiBold,
        textAlign: "center",
        ...sx,
      }}
    >
      {children}
    </Text>
  );
}
